import React, { useState } from 'react';
import { Card, Modal, Button, Col, Form } from 'react-bootstrap';
import { API_URL, apiFetch } from '../../utils/api';

export default function Cards({ cards }) {
  // Состояния для первого окна (детали услуги)
  const [showDetail, setShowDetail] = useState(false);
  const [cardModal, setCardModal] = useState({});

  // Состояния для второго окна (форма заявки)
  const [showLeadForm, setShowLeadForm] = useState(false);
  const [firstName, setName] = useState('');
  const [phone, setPhone] = useState('');

  // Функции управления окнами
  const handleCloseDetail = () => setShowDetail(false);
  const handleShowDetail = (card) => {
    setCardModal(card);
    setShowDetail(true);
  };

  const handleShowLeadForm = () => {
    setShowDetail(false); // Закрываем окно деталей
    setShowLeadForm(true); // Открываем форму
  };

  const handleCloseLeadForm = () => {
    setShowLeadForm(false);
    setName('');
    setPhone('');
  };

  const handleSubmitLead = async (e) => {
    e.preventDefault();
    try {
      const res = await apiFetch('/api/send-mail', {
        method: "POST",
        body: JSON.stringify({ name: firstName, phone })
      });

      const data = await res.json();

      if (res.status === 422) {
        // Если бэкенд вернул ошибку валидации
        alert("Ошибка: Проверьте правильность номера телефона (мин. 5 цифр)");
        return;
      }

      if (res.ok) {
        alert("Заявка успешно отправлена!");
        handleCloseLeadForm();
      } else {
        alert(data.detail || "Ошибка при отправке");
      }
    } catch (err) {
      alert("Ошибка сети");
    }
  };

  if (cards.length === 0) {
    return (
      <div className="text-center py-5 bg-white rounded-3 shadow-sm w-100">
        <i className="bi bi-search fs-1 text-muted mb-3 d-block"></i>
        <h4 className="fw-bold">Ничего не найдено</h4>
        <p className="text-muted">Попробуйте изменить параметры фильтрации</p>
      </div>
    );
  }

  return (
    <>
      <div className='row g-4'>  
        {cards.map(card => (
          <Col xs={12} sm={6} md={6} xl={4} key={card.card_id}>
            <Card className='corp-card h-100 w-100' onClick={() => handleShowDetail(card)} style={{ cursor: 'pointer' }}>
              <div className='ratio ratio-4x3 bg-light'>
                <Card.Img variant="top" className='object-fit-cover' src={`${API_URL}/${card.image}`} />
              </div>
              <Card.Body className="d-flex flex-column p-4">
                <div className="mb-2">
                  <span className="badge bg-light text-muted fw-normal text-uppercase" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>
                    {card.category?.name || 'Услуга'}
                  </span>
                </div>
                <Card.Title className="mb-3 h5 fw-bold">{card.title}</Card.Title>
                <Card.Text className='truncate-multiline small text-muted mb-4'>{card.description}</Card.Text>
                <div className='mt-auto d-flex justify-content-between align-items-center border-top pt-3'>
                  <span className="card-price">от {card.price} ₽</span>
                  <span className="small fw-bold text-uppercase" style={{ fontSize: '0.7rem', letterSpacing: '1px' }}>
                    Подробнее <i className="bi bi-arrow-right ms-1"></i>
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </div>

      {/* ОКНО 1: Описание услуги */}
      <Modal show={showDetail} onHide={handleCloseDetail} centered size="lg">
        <Modal.Header closeButton className="border-0 px-4 pt-4">
          <Modal.Title className="fw-bold fs-3">{cardModal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className='ratio ratio-16x9 mb-4 shadow-sm rounded-3 overflow-hidden'>
            <img className='object-fit-cover' src={`${API_URL}/${cardModal.image}`} alt={cardModal.title}/>
          </div>
          <div className="mb-4">
             <p className="text-dark fs-5 lh-lg" style={{ whiteSpace: 'pre-wrap' }}>{cardModal.description}</p>
          </div>
          <div className="d-flex justify-content-between align-items-center bg-light p-4 rounded-3">
             <div>
                <div className="text-muted small text-uppercase fw-bold">Ориентировочная стоимость</div>
                <div className="fs-2 fw-bold text-accent" style={{ color: 'var(--corp-accent)' }}>от {cardModal.price} ₽</div>
             </div>
             {/* Кнопка ТЕПЕРЬ открывает форму */}
             <Button className="btn-corp btn-lg px-5" onClick={handleShowLeadForm}>ЗАКАЗАТЬ</Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* ОКНО 2: Форма заявки */}
      <Modal show={showLeadForm} onHide={handleCloseLeadForm} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold fs-4 text-uppercase">Оставить заявку</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <Form onSubmit={handleSubmitLead}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted text-uppercase">Ваше имя</Form.Label>
              <Form.Control 
                className="bg-light border-0 py-3 shadow-none" 
                placeholder="Иван Иванов"
                value={firstName} 
                onChange={e => setName(e.target.value)} 
                required 
              />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="small fw-bold text-muted text-uppercase">Номер телефона</Form.Label>
              <Form.Control 
                className="bg-light border-0 py-3 shadow-none" 
                placeholder="+7"
                value={phone} 
                onChange={e => setPhone(e.target.value)} 
                required 
              />
            </Form.Group>
            <Button type='submit' className="btn-corp w-100 py-3 fw-bold">
              ОТПРАВИТЬ ДАННЫЕ
            </Button>
            <div className="text-center mt-3 small text-muted">
              Наш менеджер перезвонит вам в течение 15 минут.
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
